<template>
  <div class="ManageGroupCourseFilter">
    <div class="container-fluid ">
		  <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12 h-100 margin-Top-3Perc margin-bottom-2Perc vertical-align">
		    <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 ">
        </div>
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 font-size-18px padding-right-0Perc">
          Group
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 text-align-left">
          <div class="row">  
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <select class="form-control width-90Perc" v-model="selectedGroupObj">
                <option value=-1 disabled>Select</option>
                <option v-for="groupObj in getGroupList" v-bind:key="groupObj.GroupId" v-bind:value="groupObj">{{ groupObj.GroupName }}</option>
              </select>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 padding-Left-0px text-align-center">  
              <button type="button" class="btn black-border custom-btn white-BG" @click="showList($event)">Go</button>
            </div>
            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
            </div>
            <!--<div class="col-xs-4 col-sm-4 col-md-6 col-lg-6 left-border padding-Left-30px">  
                <button type="button" class="btn black-border custom-btn white-BG">+ Create New</button>
            </div>-->
          </div>
        </div>   
      </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>   
  </div>
</template>

<script>
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { groupService } from '@/server-util/group-service'
import Loader from '@/components/dashboard/Loader'
export default {
  created: function () {
    this.getGroups()
  },
  data: function () {
    return {
      selectedGroupObj: -1,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    getGroupList: {
      get: function () {
        return this.$store.state.groupList
      }
    }
  },
  methods: {
    getGroups: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null ||
        storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        } else {
          _this.groupList = storeObj.state.groupList
        }
        groupService.listGroups(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    showList: function (event) {
      // AK: As soon as user pressed Go Button then check is user selected any group or not
      if (this.selectedGroupObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group to view associated course master.'
        return
      }
      // AK: If selected then emit event with selectedGroupObj (ManageGroupCourse file)
      this.$emit('selectedGroupObj', this.selectedGroupObj)
    }
  },
  name: 'ManageGroupCourseFilter'
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ManageGroupCourse {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.font-size-18px
{
  font-size:18px;
}
.font-size-20px
{
  font-size:20px;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.padding-right-0Perc{
  padding-right:0%;
}
</style>



// WEBPACK FOOTER //
// src/components/ManageGroupCourseFilter.vue